export const MODAL_WRAPPER_CLASS = 'user_page_v2_perseus';

export const COUPON_LEARN_MORE_URL = '/support/articles/360017987437-Seller-Coupons';
export const REFERRERS = {
    EMAIL: 'email',
    NOTIFICATION: 'notification'
};
